import { z } from 'zod';

/** Moves the hunting engine accepts. Must match game-core's `HuntingMove`. */
export const huntingMoveSchemas = [
  z.object({ type: z.literal('scout'), cell: z.number().int().min(0).max(99) }),
  z.object({ type: z.literal('strike'), tick: z.number().int().min(0).max(60 * 30) }),
] as const;

const cell = z.union([
  z.null(),
  z.object({ kind: z.literal('tracks'), dir: z.enum(['→', '←', '↓', '↑']).nullable(), fresh: z.boolean() }),
  z.object({ kind: z.literal('rustle') }),
  z.object({ kind: z.literal('empty') }),
  z.object({ kind: z.literal('quarry') }),
]);

export const huntingViewSchema = z.object({
  size: z.number().int(),
  cells: z.array(cell),
  turns: z.number().int(),
  turnsLeft: z.number().int(),
  phase: z.enum(['track', 'strike']),
  bird: z.boolean(),
  speed: z.number(),
  ring: z.object({ start: z.number(), target: z.number(), perfect: z.number(), good: z.number(), rate: z.number() }),
  last: z.string().nullable(),
  over: z.boolean(),
  prey: z.number().int().nullable(),
});
export type HuntingView = z.infer<typeof huntingViewSchema>;
